/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ActivityQueueNotificationsForSecurityThreats extends models.ActivityQueueNotifications {
    getFixupPrototypeFunction() { return ActivityQueueNotificationsForSecurityThreats.fixupPrototype; }

    static newInstance(model: Partial<ActivityQueueNotificationsForSecurityThreats>): ActivityQueueNotificationsForSecurityThreats {
        let obj = Object.assign(new ActivityQueueNotificationsForSecurityThreats(), model);
        ActivityQueueNotificationsForSecurityThreats.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ActivityQueueNotificationsForSecurityThreats>): ActivityQueueNotificationsForSecurityThreats {
        if (!model) return null;
        return ActivityQueueNotificationsForSecurityThreats.newInstance(<ActivityQueueNotificationsForSecurityThreats> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ActivityQueueNotificationsForSecurityThreats) {
        if (!obj) return;

        models.ActivityQueueNotificationsForSecurityThreats.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ActivityQueueNotificationsForSecurityThreats): boolean {
        if (models.ActivityQueueNotifications.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ActivityQueueNotificationsForSecurityThreats.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.ticketing_enabled_from === "string") {
            this.ticketing_enabled_from = new Date(<string><any>this.ticketing_enabled_from);
        }
    }

    /**
     * Severity findings for security threats.
     */
    severities: Array<models.Severity>;

    /**
     * UTC timestamp this category was last enabled for ITSM ticketing. Threats first seen before this time are not ticketed for that initial occurrence, but are ticketed if they recur afterwards. Empty when never enabled.
     */
    ticketing_enabled_from: Date;

}
